import React from 'react'
import styled from 'styled-components'
import theme, { mobileSize } from 'theme'
import HotTagImg2x from '/static/images/hot@2x.png'
import HotTagImg3x from '/static/images/hot@3x.png'
import defaultImg from '/static/images/image-placeholder.png'
import { DesktopOnly } from 'components/LayoutUtils'
import PointSvg from '/static/images/ic-point-light-blue.svg'

const ContentCard = ({
  children,
  showMask,
  showMaskImg,
  maskImage,
  title,
  merchantName,
  showHot,
  coverImage,
  onClick,
}) => {
  return (
    <CardContainer showMask={showMask} onClick={onClick}>
      <ImgWapper showMaskImg={showMaskImg}>
        <CoverImage
          src={coverImage || defaultImg}
          onerror={`this.src=${defaultImg}`}
        />
        {(showMask || showMaskImg) && <InvalidTag unUseableImg={maskImage} />}
      </ImgWapper>
      <SkuInfoWrapper>
        <SkuTitle>{title}</SkuTitle>
        <DesktopOnly>
          <MerchantName>{merchantName}</MerchantName>
        </DesktopOnly>
        <CardBottom>{children}</CardBottom>
      </SkuInfoWrapper>
      {/* only show in sku list */}
      {showHot && (
        <HotTag
          src={HotTagImg2x}
          srcset={`${HotTagImg2x} 2x,
              ${HotTagImg3x} 3x`}
        />
      )}
    </CardContainer>
  )
}

export const CardContainer = styled.div`
  width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.05);
  position: relative;
  cursor: pointer;
  background-color: ${theme.color.white};
  user-select: none;
  outline: none;
  -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
  appearance: none;
  @media ${mobileSize} {
    box-shadow: none;
    display: flex;
  }
  &::after {
    content: ' ';
    display: ${(p) => (p.showMask ? 'block' : 'none')};
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    background-color: ${(p) => p.showMask && 'rgba(255,255,255,0.6)'};
  }
`
export const ImgWapper = styled.div`
  width: 100%;
  height: 0;
  /* height = width * 56% */
  padding-bottom: 56%;
  position: relative;
  border-bottom: 1px solid ${theme.color.grey50};
  opacity: ${(p) => p.showMaskImg && 0.5};
  @media ${mobileSize} {
    height: 0;
    width: 40%;
    padding-bottom: 30%;
    border-radius: 4px;
    &::before {
      content: ' ';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: ${theme.color.blue20};
      position: absolute;
      right: -4px;
      top: -4px;
      z-index: 2;
    }
    &::after {
      content: ' ';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: ${theme.color.blue20};
      position: absolute;
      right: -4px;
      bottom: -4px;
      z-index: 2;
    }
  }
`
export const CoverImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 4px 4px 0 0;
  position: absolute;
  top: 0;
  left: 0;
  @media ${mobileSize} {
    border-radius: 4px;
    object-fit: cover;
  }
`
export const InvalidTag = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 4px 4px 0 0;
  position: absolute;
  top: 0;
  left: 0;
  background: url(${(p) => p.unUseableImg}) no-repeat center;
  background-size: 120px 120px;
  z-index: 2;
  @media ${mobileSize} {
    background-size: 50%;
  }
`

export const SkuInfoWrapper = styled.div`
  padding: 16px;
  border-radius: 0 0 4px 4px;
  @media ${mobileSize} {
    padding: 0 16px;
    display: flex;
    align-self: center;
    flex-direction: column;
    width: 60%;
  }
`
export const SkuTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${theme.color.dark200};
  word-break: break-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 1.5;
  min-height: 1.5em;
  @media ${mobileSize} {
    font-size: 14px;
    white-space: normal;
    /* stylelint-disable value-no-vendor-prefix */
    display: -webkit-box;
    /* stylelint-disable property-no-vendor-prefix */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
`

export const MerchantName = styled.div`
  font-size: 12px;
  color: ${theme.color.grey400};
  padding-bottom: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
export const CardBottom = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  min-height: 2em;
  @media ${mobileSize} {
    padding-top: 4px;
    flex-direction: ${(p) => p.isCoupon && 'column'};
  }
`
export const PointerLabel = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${(p) => p.theme.color.blue200};
  display: flex;
  align-items: center;
  @media ${mobileSize} {
    font-size: 16px;
  }
`
export const AddSpan = styled.span`
  font-size: 12px;
  font-weight: normal;
  padding: 0 2px;
`
export const PointIcon = styled(PointSvg)`
  width: 16px;
  height: 18px;
  margin-right: 2px;
`

export const FreePointLabel = styled.label`
  font-size: 18px;
  @media ${mobileSize} {
    font-size: 14px;
  }
`
export const ExpireWapper = styled.div`
  display: flex;
  flex: 1;
`

export const ExpireLabel = styled.div`
  font-size: 14px;
  color: #d90a4c;
  @media ${mobileSize} {
    font-size: '12px';
  }
`
export const DeadlineLabel = styled.div`
  font-size: 14px;
  color: ${theme.color.dark200};
  padding-right: 2px;
  @media ${mobileSize} {
    font-size: 12px;
  }
`

export const HotTag = styled.img`
  width: 66px;
  height: 24px;
  object-fit: contain;
  position: absolute;
  top: 8px;
  left: -4px;
`
export const StoreLink = styled.div`
  font-size: 14px;
  color: ${theme.color.blue200};
  @media ${mobileSize} {
    font-size: 12px;
  }
`

export default ContentCard
